class RoleConst {
    static Call = 'act_call';
}
export default RoleConst;